import React from 'react';
import { motion } from 'framer-motion';
export function HeroSection() {
  return <section className="w-full bg-[#0f1724] py-10 md:py-24 px-4 overflow-hidden" data-id="element-96">
      <div className="max-w-4xl mx-auto flex flex-col items-center" data-id="element-97">
        {/* Product Image - Mobile: Top, Desktop: Side or Top depending on preference.
            The prompt asks for "centered layout with product image on one side (or centered above on mobile)".
            Given it's a sales letter, a centered stack often works best for the "editorial" feel,
            but I'll make it a nice grid on large screens if it fits, or keep it centered for maximum focus.
            Let's go with a centered stack for the main headline impact, then the image.
         */}

        <motion.div initial={{
        opacity: 0,
        y: 30
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.8
      }} className="text-center mb-8 md:mb-12" data-id="element-98">
          <h1 className="font-serif text-2xl sm:text-3xl md:text-5xl lg:text-6xl font-bold text-[#c9a84c] leading-tight mb-4 md:mb-8 max-w-3xl mx-auto drop-shadow-sm" data-id="element-99">
            The "Shadow" Rental Method: How to Control Prime Real Estate in
            Florida & Texas for $800+ Monthly Profit… Without Ever Talking to a
            Bank.
          </h1>
        </motion.div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-6 md:gap-12 items-center w-full" data-id="element-100">
          {/* Product Image */}
          <motion.div initial={{
          opacity: 0,
          x: -30
        }} animate={{
          opacity: 1,
          x: 0
        }} transition={{
          duration: 0.8,
          delay: 0.2
        }} className="flex justify-center md:justify-end" data-id="element-101">
            <div className="relative group" data-id="element-102">
              <div className="absolute -inset-1 bg-gradient-to-r from-[#c9a84c] to-[#d4af37] rounded-lg blur opacity-20 group-hover:opacity-30 transition duration-1000" data-id="element-103"></div>
              <img src="https://cdn.magicpatterns.com/uploads/vD1fvQ2KC2usfYbP7kGwXB/heylloyd-image-1771358355863.png" alt="The Shadow Rental Method Blueprint on a tablet" className="relative w-full max-w-[320px] md:max-w-md rounded-lg shadow-2xl border border-[#c9a84c]/20 transform transition-transform duration-700 hover:scale-[1.02]" data-id="element-104" />
            </div>
          </motion.div>

          {/* Lead Copy */}
          <motion.div initial={{
          opacity: 0,
          x: 30
        }} animate={{
          opacity: 1,
          x: 0
        }} transition={{
          duration: 0.8,
          delay: 0.4
        }} className="space-y-4 md:space-y-6 text-base md:text-xl text-[#f5f0e8]/90 leading-relaxed font-sans" data-id="element-105">
            <p data-id="element-106">
              <span className="font-bold text-[#c9a84c]" data-id="element-107">
                If you're over 50, you've felt it.
              </span>
            </p>
            <p data-id="element-108">
              The quiet anxiety when you check your 401k. The frustration of
              seeing property taxes in Florida or Texas eat 40% of your rental
              income. The realization that the "old way" of investing—buying a
              house and waiting 30 years—doesn't work when you only have 15
              years until retirement.
            </p>
            <p className="font-semibold text-white italic border-l-2 border-[#c9a84c] pl-4" data-id="element-109">
              The math is broken. But the demand for housing isn't.
            </p>
          </motion.div>
        </div>
      </div>
    </section>;
}